import { ApolloError, useQuery } from '@apollo/client';
import { GET_QUALITATIVE_FACTORS_WITH_IT_APPLICATIONS } from '../graphql';
import { CyberHubApplicationData } from '../types/it-applications';

type QualitativeFactorWithItApplications = {
  uuid: string;
  name: string;
  itApplications: CyberHubApplicationData[];
  __typename?: string;
};

/**
 * Hook to fetch qualitative factors with their associated IT applications.
 *
 * @param qualitativeFactorUUID - The UUID of the qualitative factor to fetch applications for.
 * @param locationUUID - The UUID of the location to fetch applications for.
 * @returns The business function with its associated IT applications.
 */
export const useQualitativeFactorsItApplications = (
  qualitativeFactorUUID: string,
  locationUUID: string,
): {
  data: QualitativeFactorWithItApplications | undefined;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const result = useQuery(GET_QUALITATIVE_FACTORS_WITH_IT_APPLICATIONS, {
    variables: { qualitativeFactorUUID, locationUUID },
  });

  if (result.error) {
    console.error(
      'useQualitativeFactorsItApplications GraphQL error:',
      result.error,
    );
  }

  return {
    data: result.data?.getQualitativeFactorsWithItApplications,
    loading: result.loading,
    error: result.error,
  };
};
